import { render } from "./GamePlay.vue?vue&type=template&id=22a93537"
import script from "./GamePlay.vue?vue&type=script&lang=js"
export * from "./GamePlay.vue?vue&type=script&lang=js"

import "./GamePlay.vue?vue&type=style&index=0&id=22a93537&lang=scss"
script.render = render

export default script